const checkIfValidDate = (dataVencimento) => {
  if (!(dataVencimento instanceof Date)) {
    dataVencimento = new Date(dataVencimento);
    if (isNaN(dataVencimento)) {
      console.error('dataVencimento não é uma data válida');
      return false;
    }
  }
};

const todayDate = () => {
  const dataDeHoje = new Date();
  dataDeHoje.setHours(0, 0, 0, 0);
  return dataDeHoje;
};

export default function verificaSeParcelaAtrasada(dataVencimento) {
  if (checkIfValidDate(dataVencimento)) {
    return;
  }

  const hoje = todayDate();

  const billDueDate = new Date(dataVencimento);

  billDueDate.setHours(0, 0, 0, 0);

  return hoje.getTime() > billDueDate.getTime();
}

// export function verificaSeParcelaValida(dataVencimento) {

//   if (!checkIfValidDate(dataVencimento)) {
//     return;
//   }

//   dataVencimento.setHours(0, 0, 0, 0);

//   return todayDate().getTime() < dataVencimento.getTime();
// }
